import { useEffect, useRef } from 'react';

let sharedSource = null;
let listenerCount = 0;
const handlers = {};

function getSource() {
  if (!sharedSource || sharedSource.readyState === EventSource.CLOSED) {
    const token = localStorage.getItem('token') || '';
    sharedSource = new EventSource(`/api/events?token=${encodeURIComponent(token)}`);
    sharedSource.onerror = () => {};
  }
  return sharedSource;
}

function addHandler(event, fn) {
  if (!handlers[event]) handlers[event] = new Set();
  handlers[event].add(fn);

  const source = getSource();
  if (handlers[event].size === 1) {
    source.addEventListener(event, dispatch);
  }
  listenerCount++;
}

function removeHandler(event, fn) {
  if (handlers[event]) {
    handlers[event].delete(fn);
    if (handlers[event].size === 0) {
      delete handlers[event];
      if (sharedSource) {
        sharedSource.removeEventListener(event, dispatch);
      }
    }
  }
  listenerCount--;
  if (listenerCount <= 0 && sharedSource) {
    sharedSource.close();
    sharedSource = null;
    listenerCount = 0;
  }
}

function dispatch(e) {
  const fns = handlers[e.type];
  if (!fns) return;
  let data;
  try { data = JSON.parse(e.data); } catch { data = {}; }
  for (const fn of fns) fn(data);
}

/**
 * Subscribe to a server-sent event. The callback fires whenever the server
 * broadcasts the given event type. A single shared EventSource is used
 * across all components in the tab.
 *
 * @param {string} eventType  e.g. 'bookings:changed', 'slots:changed'
 * @param {function} callback receives the parsed JSON payload
 */
export default function useSSE(eventType, callback) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    const handler = (data) => cbRef.current(data);
    addHandler(eventType, handler);
    return () => removeHandler(eventType, handler);
  }, [eventType]);
}
